// src/redux/slices/comboSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define ComboResponse type based on the actual API response
export interface ComboResponse {
  combos: Array<{
    combo_id: string;
    restaurant_id: string;
    title: string;
    description: string;
    products: Array<{
      pk_id: string;
      name: string;
      price: string;
      image?: string;
      description?: string;
      food_type?: string;
      is_vegan?: string;
    }>;
    combo_price: string; // API returns string like "$74.60"
    offer_percentage: number;
    combo_image?: string;
    is_enabled: boolean;
    created_date: string;
  }>;
}

interface ComboState {
  data: ComboResponse['combos'] | null;
  loading: boolean;
  error: string | null;
}

const initialState: ComboState = {
  data: null,
  loading: false,
  error: null,
};

export const comboSlice = createSlice({
  name: 'combo',
  initialState,
  reducers: {
    // Fetch combo actions
    fetchComboRequest: state => {
      state.loading = true;
      state.error = null;
    },
    fetchComboSuccess: (state, action: PayloadAction<ComboResponse['combos']>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchComboFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

export const {
  fetchComboRequest,
  fetchComboSuccess,
  fetchComboFailure,
} = comboSlice.actions;

export default comboSlice.reducer;
